module.exports = __webpack_public_path__ + "img/icon-advantage@3x6.9026da21.png";